import React, { useState, useEffect } from 'react';

const BatteryBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      setScrollProgress(Math.min(100, Math.max(0, scrollPercent)));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="flex items-center">
      {/* Modern Progress Bar */}
      <div className="relative">
        {/* Background Track */}
        <div className="w-1 h-8 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
        
        {/* Progress Fill */}
        <div 
          className="absolute bottom-0 left-0 w-full rounded-full transition-all duration-300 ease-out"
          style={{
            height: `${scrollProgress}%`,
            background: `var(--color-primary)`,
            opacity: scrollProgress > 0 ? 1 : 0
          }}
        ></div>
      </div>
    </div>
  );
};

export default BatteryBar;
